import React from 'react';
import LazyPageLoader from './cmp/LazyPageLoader';

const Page = React.lazy(()=>import('./Dashboard'))

export default function CustomPageLazy(){
    return <React.Suspense fallback={<LazyPageLoader />}>
        <Page />
    </React.Suspense>
}
